import 'custom-select'

export default {
  init() {
    // document.getElementsByTagName('body')[0].classList.remove('vis-none')

    // document.onload = () => {
    //   document.getElementsByTagName('body')[0].classList.add('test-vis-vis-vis')
    // }

    document.addEventListener(
      'load',
      function () {
        console.log('test-vis-siv')
      },
      false
    )

    // Select Styles
    let customSelect = require('custom-select').default
    const fieldsGFSelect = document.querySelectorAll('.gfield select')
    fieldsGFSelect.forEach(fieldGF => {
      customSelect(fieldGF)
    })
    const fieldsGF = document.querySelectorAll(
      '.gfield input, .gfield textarea, .gfield select'
    )
    // Upload GF field style
    Array.from(fieldsGF).map(fieldGF => {
      fieldGF.addEventListener('change', function () {
        if (fieldGF.getAttribute('type') === 'file') {
          const arrayFiles = fieldGF.value.split('\\')
          if (arrayFiles) {
            const prev = fieldGF.parentElement.querySelector('span')
            prev?.remove()
            let categorySpan = document.createElement('span')
            categorySpan.textContent = arrayFiles[arrayFiles.length - 1]
            fieldGF.parentElement.appendChild(categorySpan)
          }
        }
        if (fieldGF.value !== '') {
          fieldGF.classList.add('filled')
        } else {
          fieldGF.classList.remove('filled')
        }
      })
    })

    // Run scripts after page is loaded
    var handleAfterPageLoad = function () {
      document
        .getElementsByTagName('body')[0]
        .classList.remove('content-not-visible')

      scrollToTargetAfterLoadPage()
    }

    // Scroll to target after page is loaded
    const scrollToTargetAfterLoadPage = () => {
      const targetId = window.location.hash.slice(1)
      const target = document.getElementById(targetId)
      if (target) {
        setTimeout(() => {
          scrollToTarget(target, 200)
        }, 700)
      }
    }

    window.addEventListener('load', handleAfterPageLoad, false)
    window.addEventListener('hashchange', scrollToTargetAfterLoadPage, false)

    document
      .querySelector('.share--title')
      ?.addEventListener('click', function () {
        document.querySelector('.share-links')?.classList.toggle('hidden')
      })

    document
      .querySelector('.academy-more-info')
      ?.addEventListener('click', function () {
        document.querySelector('.content.hidden')?.classList.remove('hidden')
        this.remove()
      })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    wrapHeadingsForGradient()
    let gfConfirmation = document.querySelector('.gform_confirmation_message')
    if (gfConfirmation) {
      scrollToTarget(gfConfirmation, 200)
    }
    if (typeof jQuery !== 'undefined') {
      // eslint-disable-next-line no-undef
      jQuery(document).on('gform_confirmation_loaded', function () {
        // eslint-disable-next-line no-undef
        let gfConfirmation = document.querySelector(
          '.gform_confirmation_message'
        )
        if (gfConfirmation) {
          scrollToTarget(gfConfirmation, 200)
        }
      })
    }
  },
}

const wrapHeadingsForGradient = () => {
  const headings = document.querySelectorAll('.wp-block-heading')

  Array.from(headings).map(heading => {
    const text = heading.innerHTML
    heading.innerHTML = `<span>${text}</span>`
  })
}

export const scrollToTarget = (target, offset = 0) => {
  const targetPosition = target.getBoundingClientRect().top + window.scrollY
  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: targetPosition - offset,
  })
}

export const scrollToForm = element => {
  const headerHeight = document.querySelector('header')?.offsetHeight
  const y =
    element.getBoundingClientRect().top + window.pageYOffset - headerHeight
  window.scrollTo({ top: y, behavior: 'smooth' })
}
